<ngx-skeleton-loader [theme]="{ height: '32px', width: '250px', 'max-width': '100%' }"></ngx-skeleton-loader>
